export type IRoleRight =
    | 'ROOOOT'
    | 'ROOT'
    | 'LORD'
    | 'ADMIN'
    | 'CUSTOMER_CARE'
    | 'RESELLER'
    | 'FINANCE'
    | 'USER'
    | 'READONLY_USER';
export type IRole =
    | 'RooT'
    | 'root'
    | 'lord'
    | 'admin'
    | 'customer_care'
    | 'reseller'
    | 'finance'
    | 'user'
    | 'readonly_user';
export type IRealRole = IRole | undefined;

type IRoleRightMap = {
    [id in IRole]: Array<IRoleRight>;
};

export class RoleRightMap {
    private readonly _map: IRoleRightMap = {
        RooT: ['ROOOOT', 'ROOT', 'LORD', 'ADMIN', 'CUSTOMER_CARE', 'RESELLER', 'FINANCE', 'USER', 'READONLY_USER'],
        root: ['ROOT', 'LORD', 'ADMIN', 'CUSTOMER_CARE', 'RESELLER', 'FINANCE', 'USER', 'READONLY_USER'],
        lord: ['LORD', 'ADMIN', 'CUSTOMER_CARE', 'RESELLER', 'FINANCE', 'USER', 'READONLY_USER'],
        admin: ['ADMIN', 'CUSTOMER_CARE', 'FINANCE', 'USER', 'READONLY_USER'],
        customer_care: ['CUSTOMER_CARE', 'USER', 'READONLY_USER'],
        reseller: ['RESELLER', 'USER', 'READONLY_USER'],
        finance: ['FINANCE', 'USER', 'READONLY_USER'],
        user: ['USER', 'READONLY_USER'],
        readonly_user: ['READONLY_USER'],
    };
    private readonly _role: IRole;
    constructor(role?: IRole) {
        this._role = role ? role : 'readonly_user';
    }

    // public getRight(): Array<IRoleRight> {
    //     return this._map[this._role];
    // }
    public isRight(right: IRoleRight): boolean {
        return this._map[this._role]?.includes(right);
    }
}

export const isRoleRight = (right?: Array<IRoleRight>, role?: IRole): boolean => {
    if (!right) {
        return true;
    } else {
        const rightMap = new RoleRightMap(role);
        let isRight = false;
        right.forEach((r) => {
            if (rightMap.isRight(r)) {
                isRight = true;
            }
        });
        return isRight;
    }
};
